import { Link } from 'react-router-dom'
import { IconCart } from '../common'

const ChkoutLinkButton = () => {
  return (
    <Link to='cart'><IconCart /></Link>
  )
}
export default ChkoutLinkButton